module.exports = __webpack_public_path__ + "assets/img/35cae89aec9c8d37a8389e911e79dbbb.png";